(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_banner-parent"] && !Shopify.designMode) return;
  try {
    function initBannerGrid() {
    const bannerParents = document.querySelectorAll('.banner-parent');
    bannerParents.forEach(function (bannerParent) {
      const bannerItems = bannerParent.querySelectorAll('.banner-item');
      bannerParent.classList.add('grid-' + bannerItems.length);
    });
  }

  initBannerGrid();  
  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', initBannerGrid);
    document.addEventListener('shopify:section:deselect', initBannerGrid);
    document.addEventListener('shopify:section:reorder', initBannerGrid);
    document.addEventListener('shopify:block:select', initBannerGrid);
    document.addEventListener('shopify:block:deselect', initBannerGrid);
    document.addEventListener('shopify:section:load', initBannerGrid);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-k24-buy-notes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('k24-delivery-estimate')) {
    customElements.define(
      'k24-delivery-estimate',
      class extends HTMLElement {
        connectedCallback() {
          const min = Number.parseInt(this.dataset.minDays, 10);
          const max = Number.parseInt(this.dataset.maxDays, 10);
          const template = this.dataset.template;
          if (!(min >= 0) || !(max >= min) || !template) return;
          // Working days only (Mon-Fri), from today in the shopper's own time
          // zone. Public holidays are not skipped.
          const addWorkingDays = (days) => {
            const date = new Date();
            let left = days;
            while (left > 0) {
              date.setDate(date.getDate() + 1);
              const day = date.getDay();
              if (day !== 0 && day !== 6) left -= 1;
            }
            return date;
          };
          const locales = { nl: 'nl-NL', de: 'de-DE', fr: 'fr-FR', en: 'en-GB' };
          const lang = (this.dataset.locale || document.documentElement.lang || 'nl').slice(0, 2);
          let format;
          try {
            format = new Intl.DateTimeFormat(locales[lang] || lang, { weekday: 'short', day: 'numeric', month: 'short' });
          } catch (error) {
            return;
          }
          // fr/de short months end in a dot ("oct."); drop the sentence's own
          // full stop right after one, so it never reads "oct..".
          this.innerHTML = template
            .replace('__FROM__', format.format(addWorkingDays(min)))
            .replace('__TO__', format.format(addWorkingDays(max)))
            .replace(/\.(<\/strong>)\./g, '.$1');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_slide-parent"] && !Shopify.designMode) return;
  try {
    function addAnimateDelayToSlides() {
    const swiperWrappers = document.querySelectorAll('.swiper-wrapper_parent');
    swiperWrappers.forEach(function(swiperWrapper) {
      const slideItems = swiperWrapper.querySelectorAll('.swiper-slide_item');
      slideItems.forEach(function(slideItem, index) {
        if (index > 0) {
          const contentSlides = slideItem.querySelectorAll('.content-slide');
          contentSlides.forEach(function(contentSlide) {
            contentSlide.classList.add('animate-delay');
          });
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', addAnimateDelayToSlides);
  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:deselect', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:reorder', addAnimateDelayToSlides);
    document.addEventListener('shopify:block:select', addAnimateDelayToSlides);
    document.addEventListener('shopify:block:deselect', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:load', addAnimateDelayToSlides);
  }
  } catch(e) { console.error(e); }
})();

})();
